module.exports = __webpack_public_path__ + "static/media/graph-2.58324baa.svg";